import React from 'react';
import ReactDOM from 'react-dom';

import getDataAttributeProps from '../../util/getDataAttributeProps';

import UserRoutingSurvey from './userRoutingSurvey';

const root = document.getElementById('user-routing-survey');

const surveyProps = getDataAttributeProps(root);

ReactDOM.render(<UserRoutingSurvey {...surveyProps} />, root);
